export default __webpack_public_path__ + "static/team-member-5-8e0dcc6b93f2cc0aa319614cadf8aadd.png";